import { SignatureProps } from "../App";
import ImageLogo from "./ImageLogo";

const Signature = ({
  fullName,
  position,
  phone,
  banners,
  bannerType,
  selectedBannerType,
}: SignatureProps) => {
  return (
    <table
      cellPadding={0}
      cellSpacing={0}
      className={"signature"}
      style={{ fontFamily: "Arial, Helvetica, sans-serif" }}
    >
      <tbody>
        <tr>
          <td
            style={{
              backgroundImage: "linear-gradient(0deg, #0960F6 0%, #8839F5 50%, #FF290C 100%)",
              padding: 2,
            }}
          ></td>
          <td>
            <table cellPadding={0} cellSpacing={0}>
              <tbody>
                <tr>
                  <td
                    style={{
                      fontSize: 14,
                      fontWeight: 800,
                      color: "#FF290C",
                      paddingTop: 2,
                      paddingLeft: 24,
                    }}
                  >
                    {fullName}
                  </td>
                </tr>
              </tbody>
            </table>
            <table cellPadding={0} cellSpacing={0}>
              <tbody>
                <tr>
                  <td
                    colSpan={3}
                    style={{
                      fontSize: 14,
                      fontWeight: 400,
                      color: "#011840",
                      paddingLeft: 24,
                    }}
                  >
                    {position}
                  </td>
                </tr>
              </tbody>
            </table>
            <table cellPadding={24} cellSpacing={0}>
              <tbody>
                <tr>
                  <td
                    colSpan={3}
                    style={{
                      fontSize: 14,
                      fontWeight: 400,
                      color: "#011840",
                      paddingLeft: 24,
                    }}
                  >
                    {phone ? (
                      <>
                        <strong>M. </strong>
                        {phone}
                      </>
                    ) : null}
                  </td>
                </tr>
              </tbody>
            </table>
            <table cellPadding={0} cellSpacing={0}>
              <tbody>
                <tr>
                  <td colSpan={3} style={{ paddingLeft: 24 }}>
                    <a
                      href={"https://www.roller.software/"}
                      style={{ display: "flex" }}
                    >
                      <img
                        width={146}
                        src="https://signature.rollersoftware.com/email-logo.png"
                        alt="ROLLER - All-in-on Venue Management software"
                        title="Roller"
                      />
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
            <table cellPadding={0} cellSpacing={0}>
              <tbody>
                <tr>
                  <td colSpan={3} style={{ paddingLeft: 24 }}>
                    <div
                      style={{
                        display: "flex",
                        fontSize: 12,
                        color: "#011840",
                        letterSpacing: -0.16,
                        fontWeight: 400,
                        paddingTop: 8,
                      }}
                    >
                      <a
                        href={"https://www.roller.software/"}
                        title="ROLLER - All-in-on Venue Management software"
                        style={{ color: "#011840" }}
                      >
                        Website
                      </a>
                      <span style={{ marginLeft: 3, marginRight: 3 }}>|</span>
                      <a
                        href={"https://www.linkedin.com/company/roller/"}
                        title="ROLLER - LinkedIn"
                        style={{ color: "#011840" }}
                      >
                        LinkedIn
                      </a>
                      <span style={{ marginLeft: 3, marginRight: 3 }}>|</span>
                      <a
                        href={
                          "https://www.roller.software/the-guest-experience-show/"
                        }
                        title="ROLLER - The Guest Experience"
                        style={{ color: "#011840" }}
                      >
                        Podcast
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <table cellPadding={0} cellSpacing={0}>
              <tbody>
                <tr>
                  <td colSpan={3} style={{ paddingTop: 24 }}>
                    <a
                      href={
                        selectedBannerType &&
                        banners &&
                        banners[selectedBannerType]
                          ? banners[selectedBannerType].linkUrl
                          : ""
                      }
                      style={{ display: "flex" }}
                      title="ROLLER - All-in-on Venue Management software"
                    >
                      <img
                        src={
                          selectedBannerType &&
                          banners &&
                          banners[selectedBannerType]
                            ? banners[selectedBannerType].imageUrl
                            : ""
                        }
                        width={596}
                        alt="ROLLER - All-in-on Venue Management software"
                      />
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
            <table cellPadding={0} cellSpacing={0}>
              <tbody>
                <tr>
                  <td
                    colSpan={3}
                    style={{
                      fontSize: 12,
                      fontWeight: 400,
                      color: "#011840",
                      paddingLeft: 24,
                      paddingTop: 24,
                      paddingBottom: 18,
                    }}
                  >
                    Check out our consistently high industry ratings:
                  </td>
                </tr>
              </tbody>
            </table>
            <table cellPadding={0} cellSpacing={0}>
              <tbody>
                <tr>
                  <td colSpan={3} style={{ paddingLeft: 24 }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: 12,
                        color: "#011840",
                        letterSpacing: -0.16,
                        fontWeight: 400,
                        paddingTop: 8,
                      }}
                    >
                      <a
                        href={
                          "https://www.softwareadvice.com/ticketing/#frontrunners"
                        }
                        title="ROLLER - Sofware Advice"
                        style={{
                          color: "#011840",
                          paddingRight: 24,
                          verticalAlign: "middle",
                        }}
                      >
                        <ImageLogo
                          src="https://signature.rollersoftware.com/software-advice.png"
                          alt="ROLLER - Sofware Advice"
                          width={66}
                          fallbackSrc="https://signature.rollersoftware.com/software-advice.png"
                          title="ROLLER - Sofware Advice"
                        />
                      </a>
                      <a
                        href={
                          "https://www.g2.com/products/roller-software/reviews?utm_source=rewards-badge"
                        }
                        title="ROLLER - G2"
                        style={{
                          color: "#011840",
                          paddingRight: 24,
                          verticalAlign: "middle",
                        }}
                      >
                        <ImageLogo
                          width={52}
                          src="/users-love-us.png"
                          fallbackSrc="G2@2x.png"
                          alt="ROLLER - G2"
                          title="ROLLER - G2"
                        />
                      </a>
                      <a
                        href={
                          "https://www.capterra.com/ticketing-software/shortlist"
                        }
                        title="ROLLER - Capterra"
                        style={{
                          color: "#011840",
                          paddingRight: 24,
                          verticalAlign: "middle",
                        }}
                      >
                        <ImageLogo
                          src="https://signature.rollersoftware.com/capterra.png"
                          alt="ROLLER - Capterra"
                          width={72}
                          fallbackSrc="capterra.png"
                          title="ROLLER - Capterra"
                        />
                      </a>
                      <a
                        href={
                          "https://sourceforge.net/software/product/ROLLER/"
                        }
                        title="ROLLER - Sourceforge User Reviews"
                        style={{
                          color: "#011840",
                          paddingRight: 24,
                          verticalAlign: "middle",
                        }}
                      >
                        <ImageLogo
                          src="https://signature.rollersoftware.com/leader-fall.png"
                          alt="ROLLER - Sourceforge User Reviews"
                          width={52}
                          fallbackSrc="sf-winter.png"
                          title="ROLLER - Sourceforge User Reviews"
                        />
                      </a>
                      <a
                        href={
                          "https://www.getapp.com/customer-management-software/a/roller/"
                        }
                        title="ROLLER - GetApp"
                        style={{
                          color: "#011840",
                          paddingRight: 24,
                          verticalAlign: "middle",
                        }}
                      >
                        <ImageLogo
                          width={67}
                          src="/getapp.png"
                          fallbackSrc="GA-Badge.png"
                          alt="ROLLER - GetApp"
                          title="ROLLER - GetApp"
                        />
                      </a>
                      <a
                        href={"https://slashdot.org/software/p/ROLLER/"}
                        title="ROLLER - Slashdot User Reviews"
                        style={{ color: "#011840", verticalAlign: "middle" }}
                      >
                        <ImageLogo
                          src="https://signature.rollersoftware.com/slashdot-summer-white.png"
                          alt="ROLLER - Slashdot User Reviews"
                          title="ROLLER - GetApp"
                          width={46}
                          fallbackSrc="slashdot.png"
                        />
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default Signature;
